import React from 'react';
import styled from 'styled-components';
import { media } from '../themes/theme';
import { FocusStyles } from '../../styles/FocusStyles';
import { CardHeader } from './CardHeader';
import { Card, CardMediaWrapper, CardFooter, CardTitle, CardInner, } from './shared';
import { IconAdd } from './CardIcons';
const CardButton = styled.button `
  border: none;
  background: none;
  display: block;
  width: 100%;
  cursor: pointer;
  padding: 0;
  ${FocusStyles};
`;
const AddTonieInner = styled.span `
  ${CardInner}
  display: flex;
  flex-direction: column;
  padding: 0.625rem;
  background: ${props => props.theme.colors.middlegrey};

  ${media.tablet `
    padding: 1rem;
  `}
`;
const StyledTitle = styled(CardTitle) `
  /*
   * These properties are marked experimental by vendors,
   * but work in all browsers of our defined scope.
   */
  /* stylelint-disable property-no-vendor-prefix,value-no-vendor-prefix */
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: initial;
`;
export const AddCard = ({ onClick, title, 'data-trackingid': dataTrackingId, }) => {
    return (React.createElement(CardButton, { onClick: onClick, "data-testid": "add-card", "data-trackingid": dataTrackingId },
        React.createElement(Card, null,
            React.createElement(AddTonieInner, null,
                React.createElement(CardHeader, null),
                React.createElement(CardMediaWrapper, null,
                    React.createElement(IconAdd, { size: "xlarge", "aria-hidden": "true" })),
                React.createElement(CardFooter, null,
                    React.createElement(StyledTitle, null, title))))));
};
